import moment from 'moment-timezone'
import TypeBadge from '../components/TypeBadge'
import { HetPrintNewCard } from '../services/dashboard.service';
import { toTitleCase } from '../utils/formatter'


export const TABLE_HEADERS = [
  {
    label: 'Nomor Registrasi',
    value: 'registrationNumber',
  },
  {
    label: 'Waktu Registasi',
    value: 'createdAt',
    format: (value) => {
      return moment(value).tz('Asia/Jakarta').format('D MMM YYYY HH:mm:ss')
    },
  },
  {
    label: 'Nama Lengkap',
    value: 'fullname',
    format: toTitleCase,
  },
  {
    label: 'Nomor Identitas (NIK)',
    value: 'nik',
  },
  {
    label: 'Umur',
    value: 'birthDate',
    format: (value) => {
      return value ? moment().diff(value, 'years') : '-'
    },
  },
  {
    label: 'Ukuran Kaos',
    value: 'shirtSize',
  },
  {
    label: 'E-mail',
    value: 'email',
  },
  {
    label: 'Tipe',
    value: 'type',
    format: (value) => {
      return <TypeBadge type={value} />
    },
  },
  {
    label: 'Nomor Telepon',
    value: 'phoneNumber',
  },
]

export const ANGGOTA_AKTIF_TABLE_HEADERS = [
  {
    label: 'Nama Lengkap',
    value: 'fullname',
    format: toTitleCase,
  },
  {
    label: 'Nomor KTA',
    value: 'ktaNumber',
  },
  {
    label: 'Waktu Mulai',
    value: 'validAt',
    format: (value) => {
      return moment(value).tz('Asia/Jakarta').format('D MMM YYYY')
    },
  },
  {
    label: 'Waktu Berakhir',
    value: 'expiredAt',
    format: (value) => {
      return moment(value).tz('Asia/Jakarta').format('D MMM YYYY')
    },
  },
  {
    label: 'Terkoneksi',
    value: 'user',
    format: (value) => {
      return value ? (
        <div className="inline-flex items-center rounded-full bg-[#E3FCEF] px-2.5 py-1 text-[13px] font-medium text-[#006644]">
          Ya
        </div>
      ) : (
        <div className="inline-flex items-center rounded-full bg-[#FCE3E3] px-2.5 py-1 text-[13px] font-medium text-[#660000]">
          Tidak
        </div>
      )
    },
  },
  {
    label: 'Email',
    value: 'user',
    format: (value) => {
      return value?.username ?? '-'
    },
  },
  {
    label: 'Korwil',
    value: 'korwil',
    format: (value) => {
      return value?.name
    },
  },
  {
    label: 'Member Card',
    value: 'memberCard',
    format:(value)=>{
      let pat=value
      console.log("pat",pat)
      if (pat == "belum") {
        return (
          <button className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-1 text-[13px] font-medium text-yellow-800">
            {pat}
          </button>
        )
      } else if (pat == "Sudah ada") {
        return (
          <button className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-1 text-[13px] font-medium text-green-800">
            {pat}
          </button>
        )
      } else if (pat == "proses") {
        return (
          <button className="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-1 text-[13px] font-medium text-blue-800">
            {pat}
          </button>
        )
      } else {
        pat = "Tidak Diketahui"
        return (
          <button className="inline-flex items-center rounded-full bg-gray-200 px-2.5 py-1 text-[13px] font-medium text-gray-700">
            {pat}
          </button>
        )
      }
    }
  },
]

export const BERITA_TABLE_HEADERS = [
  {
    label: 'Judul',
    value: 'attributes.title',
  },
  {
    label: 'Tanggal',
    value: 'attributes.date',
    format: (value) => {
      return moment(value)
        .tz('Asia/Jakarta')
        .format('dddd, D MMM YYYY [di] HH:mm')
    },
  },
  {
    label: 'Pembuat',
    value: 'attributes.creator',
  },
]

export const BERITA_ADS_TABLE_HEADERS = [
  {
    label: 'ID',
    value: 'id',
  },
  {
    label: 'Judul',
    value: 'attributes.title',
  },
  {
    label: 'Tanggal',
    value: 'attributes.date',
    format: (value) => {
      return moment(value)
        .tz('Asia/Jakarta')
        .format('dddd, D MMM YYYY [di] HH:mm')
    },
  },
  {
    label: 'Tulisan Ribbon',
    value: 'attributes.ribbonText',
  },
]

export const PERTANDINGAN_TABLE_HEADERS = [
  {
    label: 'Judul Pertandingan',
    value: 'attributes.matchTitle',
  },
  {
    label: 'Tuan Rumah',
    value: 'attributes.teamLeftName',
  },
  {
    label: 'Tamu',
    value: 'attributes.teamRightName',
  },
  {
    label: 'Status',
    value: 'attributes.matchStatus',
  },
]

export const TOKO_TABLE_HEADERS = [
  {
    label: 'ID',
    value: 'id',
  },
  {
    label: 'Nama',
    value: 'attributes.name',
  },
  {
    label: 'E-Commerce Url',
    value: 'attributes.ecommerceUrl',
  },
  {
    label: 'isFeatured',
    value: 'attributes.isFeatured',
    format: (value) => {
      return value ? 'Benar' : 'Salah'
    },
  },
]

export const VIDEO_TABLE_HEADERS = [
  {
    label: 'Nama',
    value: 'attributes.title',
  },
  {
    label: 'Video Url',
    value: 'attributes.videoUrl',
  },
]
